import {
  GET_ADVERTISEMENTS,
  GET_ADVERTISEMENT,
  UPDATE_ADVERTISEMENT,
  CREATE_ADVERTISEMENT,
  DELETE_ADVERTISEMENT,
  GET_ADVERTISEMENTS_REQUEST_PENDING,
  GET_ADVERTISEMENTS_REQUEST_SUCCESS,
  GET_ADVERTISEMENTS_REQUEST_ERROR,
  CHANGE_ADVERTISEMENTS_REQUEST_PENDING,
  CHANGE_ADVERTISEMENTS_REQUEST_SUCCESS,
  CHANGE_ADVERTISEMENTS_REQUEST_ERROR,
} from '../types/advertisements'

const initialState = {
  items: [],
  item: {},
  isGetLoading: false,
  isChangeLoading: false,
  errors: [],
}

const advertisements = (state = initialState, action) => {
  switch (action.type) {
    case GET_ADVERTISEMENTS:
      return { ...state, items: action.payload }
    case GET_ADVERTISEMENT:
      return { ...state, item: action.payload }
    case UPDATE_ADVERTISEMENT: {
      const itemIndex = state.items.findIndex((item) => item.id === action.payload.id)
      const newItems = [...state.items]
      if (itemIndex !== -1) {
        newItems[itemIndex] = { ...action.payload }
      }
      return { ...state, items: newItems }
    }
    case CREATE_ADVERTISEMENT:
      return { ...state, items: [...state.items, action.payload] }
    case DELETE_ADVERTISEMENT:
      return {
        ...state,
        items: state.items.filter((item) => item.id !== action.payload),
      }
    case GET_ADVERTISEMENTS_REQUEST_PENDING:
      return { ...state, isGetLoading: true }
    case GET_ADVERTISEMENTS_REQUEST_SUCCESS:
      return { ...state, errors: [], isGetLoading: false }
    case GET_ADVERTISEMENTS_REQUEST_ERROR:
      return { ...state, errors: action.payload, isGetLoading: false }
    case CHANGE_ADVERTISEMENTS_REQUEST_PENDING:
      return { ...state, isChangeLoading: true }
    case CHANGE_ADVERTISEMENTS_REQUEST_SUCCESS:
      return { ...state, errors: [], isChangeLoading: false }
    case CHANGE_ADVERTISEMENTS_REQUEST_ERROR:
      return { ...state, errors: action.payload, isChangeLoading: false }
    default:
      return state
  }
}

export default advertisements
